import { prayerMethodConfig } from "@/lib/prayer-methods";

export const appName = "Ummah Wahidah";
export { prayerMethodConfig };

export const panelClassName =
  "flex h-full flex-col rounded-2xl border border-zinc-800/50 bg-zinc-950/90 backdrop-blur-md";

export const cardClassName = "rounded-2xl border border-zinc-800/50 bg-zinc-950/90 backdrop-blur-md";

export const experienceDescriptions = [
  {
    description: "Hover the curated markers to see the live local prayer state.",
    title: "Explore the Globe",
  },
  {
    description: "Browse cities grouped by continent and focus one instantly.",
    title: "Locations",
  },
  {
    description: "Read today's prayer schedule with the current prayer highlighted.",
    title: "Today",
  },
  {
    description: "Switch among real Adhan calculation presets and see the schedule update instantly.",
    title: "Method",
  },
  {
    description: "Inspect each marker's embedded IANA timezone against browser time and UTC.",
    title: "Timezone",
  },
  {
    description: "Drive the globe focus state directly with orbit, next, previous, and reset controls.",
    title: "Focus",
  },
] as const;

export const hints: Record<number, string> = {
  0: "Drag to rotate · Scroll to zoom · Hover markers to preview prayer state",
  1: "Click a city in the list or on the globe to refocus instantly",
  2: "Today's timings are formatted in the selected location's timezone",
  3: "Switch between the salat10 baseline and Adhan presets without leaving the shell",
  4: "Compare the selected city's embedded timezone with your browser zone and UTC",
  5: "Use focus controls to step through cities or reset back to the wider orbit",
};
